module.exports = __webpack_public_path__ + "static/media/Coffee.25dd5675.png";